import axios from 'axios'
import {LOCAL_STORAGE, PATH, STATUS_CODE} from '@utils/Const'
import {BASE_URL} from '@utils/Const'
import {checkDataForm} from '@utils'

// const BASE_URL = 'http://192.168.22.30:8888'

const getAccessToken = () => localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)
const getRefreshToken = () => localStorage.getItem(LOCAL_STORAGE.REFRESH_TOKEN)
const getUserId = () => localStorage.getItem(LOCAL_STORAGE.USER_ID)
export default axios.create({
  baseURL: BASE_URL,
})

const axiosInstance = axios.create({
  baseURL: BASE_URL,
})

const refreshAccessToken = async () => {
  const refreshToken = getRefreshToken()
  try {
    const response = await axiosInstance.post(
      'iesv/api/v1/auth/refresh-tokens',
      {refresh_token: refreshToken},
    )
    if (response?.data?.status === STATUS_CODE.SUCCESS) {
      const newAccessToken = response?.data?.data?.accessToken
      localStorage.setItem(
        LOCAL_STORAGE.ACCESS_TOKEN,
        response?.data?.data?.accessToken,
      )
      localStorage.setItem(
        LOCAL_STORAGE.REFRESH_TOKEN,
        response?.data?.data?.refreshToken,
      )
      return newAccessToken
    } else {
      redirectToLogin()
    }
  } catch (error) {
    redirectToLogin()
  }
}

const redirectToLogin = () => {
  window.location.href = PATH.LOGIN
  localStorage.clear()
}

const addUserIdToUrl = (url: string, userId: string | null) => {
  const hasParams = url.includes('?')
  return hasParams
    ? `${url}&user-id=${userId || ''}`
    : `${url}?user-id=${userId || ''}`
}

const apiGlobal = {
  get: async (url: any, params: any) => {
    const userId = getUserId()
    const requestParams = {
      params: {
        'user-id': userId,
        ...params,
      },
    }
    return axiosInstance
      .get(url, requestParams)
      .then(res => {
        return res
      })
      .catch(handlerError)
  },
  post: async (url: any, params?: any, header?: any, isDataForm?: boolean) => {
    const userId = getUserId()
    const urlWithUserId = addUserIdToUrl(url, userId)

    let requestParams
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...header,
      },
    }
    if (isDataForm) {
      config.headers['Content-Type'] = 'multipart/form-data'
      requestParams = checkDataForm(params)
    } else {
      requestParams = {
        user_id: userId || '',
        ...params,
      }
    }
    return axiosInstance
      .post(urlWithUserId, requestParams, config)
      .then(res => {
        return res
      })
      .catch(handlerError)
  },
  patch: async (url: any, params?: any, header?: any, isDataForm?: boolean) => {
    const userId = getUserId()
    const urlWithUserId = addUserIdToUrl(url, userId)

    let requestParams
    const headers = {
      'Content-Type': 'application/json',
      ...header,
    }
    if (isDataForm) {
      requestParams = checkDataForm(params)
    } else {
      requestParams = {
        user_id: userId || '',
        ...params,
      }
    }
    return axiosInstance
      .patch(urlWithUserId, requestParams, {headers})
      .then(res => {
        return res
      })
      .catch(handlerError)
  },

  put: async (url: any, params?: any, header?: any, isDataForm?: boolean) => {
    const userId = getUserId()
    const urlWithUserId = addUserIdToUrl(url, userId)
    let requestParams
    const headers = {
      'Content-Type': 'application/json',
      ...header,
    }
    if (isDataForm) {
      requestParams = checkDataForm(params)
    } else {
      requestParams = {
        user_id: userId || '',
        ...params,
      }
    }
    return axiosInstance
      .put(urlWithUserId, requestParams, {headers})
      .then(res => {
        return res
      })
      .catch(handlerError)
  },

  authGet: async (url: any, params: any) => {
    const userId = getUserId()
    const requestParams = {
      'user-id': userId || '',
      ...params,
    }
    const accessToken = getAccessToken()
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      params: requestParams,
    }

    return axiosInstance
      .get(url, config)
      .then(res => {
        return res
      })
      .catch(async error => {
        if (error?.response?.data?.status === STATUS_CODE.TOKEN_EXPIRE) {
          const newAccessToken = await refreshAccessToken()
          config.headers.Authorization = `Bearer ${newAccessToken}`
          return axiosInstance.get(url, config).then(res => {
            return res
          })
        } else {
          if (error?.response?.status === 401) {
            redirectToLogin()
          } else {
            throw new Error(error)
          }
        }
      })
  },
  authPost: async (
    url: any,
    params: any,
    header?: any,
    isDataForm?: boolean,
  ) => {
    const accessToken = getAccessToken()
    const userId = getUserId()
    const urlWithUserId = addUserIdToUrl(url, userId)

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        ...header,
      },
    }
    let requestParams
    if (isDataForm) {
      config.headers['Content-Type'] = 'multipart/form-data'
      requestParams = checkDataForm(params)
    } else {
      config.headers['Content-Type'] = 'application/json'
      requestParams = params
    }
    return axiosInstance
      .post(urlWithUserId, requestParams, config)
      .then(res => {
        return res
      })
      .catch(async error => {
        if (error?.response?.data?.status === STATUS_CODE.TOKEN_EXPIRE) {
          let requestParams
          if (isDataForm) {
            config.headers['Content-Type'] = 'multipart/form-data'
            requestParams = checkDataForm(params)
          } else {
            config.headers['Content-Type'] = 'application/json'
            requestParams = params
          }
          const newAccessToken = await refreshAccessToken()
          config.headers.Authorization = `Bearer ${newAccessToken}`
          return axiosInstance
            .post(urlWithUserId, requestParams, config)
            .then(res => {
              return res
            })
        } else {
          if (error?.response?.status === 401) {
            redirectToLogin()
          } else {
            throw new Error(error)
          }
        }
      })
  },
  authPatch: async (
    url: any,
    params?: any,
    header?: any,
    isDataForm?: boolean,
  ) => {
    const accessToken = getAccessToken()
    const userId = getUserId()
    const urlWithUserId = addUserIdToUrl(url, userId)
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        ...header,
      },
    }
    let requestParams
    if (isDataForm) {
      config.headers['Content-Type'] = 'multipart/form-data'
      requestParams = checkDataForm(params)
    } else {
      config.headers['Content-Type'] = 'application/json'
      requestParams = params
    }
    return axiosInstance
      .patch(urlWithUserId, requestParams, config)
      .then(res => {
        return res
      })
      .catch(async error => {
        if (error?.response?.data?.status === STATUS_CODE.TOKEN_EXPIRE) {
          let requestParams
          if (isDataForm) {
            config.headers['Content-Type'] = 'multipart/form-data'
            requestParams = checkDataForm(params)
          } else {
            config.headers['Content-Type'] = 'application/json'
            requestParams = params
          }
          const newAccessToken = await refreshAccessToken()
          config.headers.Authorization = `Bearer ${newAccessToken}`
          return axiosInstance
            .patch(urlWithUserId, requestParams, config)
            .then(res => {
              return res
            })
        } else {
          if (error?.response?.status === 401) {
            redirectToLogin()
          } else {
            throw new Error(error)
          }
        }
      })
  },
}

const handlerError = async (error: any) => {
  if (error.response) {
  } else if (error.request) {
  } else {
  }
  return error
}

export {apiGlobal}
